import React, {useEffect, useState} from "react";
import AssociatePerformance from "./AssociatePerformance";
import AssociateFilterContextProvider from "./context/AssociateFilterContext";
import AssociateFilter from "./AssociateFilter";
import AssociatePerformanceContextProvider from "./context/AssociatePerformanceContext";
import Column from "@amzn/meridian/column";
import {FEATURES, PAGE_HEADERS} from "../util/Constants";
import PageHeader from "../util/PageHeader";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import AssociateScanChartView from "./AssociateScanChartView";
import AssociateScanContextProvider from "./context/AssociateScanContext";
import {getFeaturesFromParent} from "../handler/ParentDataHandler";

const Associate = () => {
    const {spacingInset_shorthand2} = useDeviceLayout();
    const [isEnabled, setIsEnabled] = useState(null);

    useEffect(() => {
        getFeaturesFromParent([FEATURES.IS_ASSOCIATE_SCAN_METRIC_ENABLED]).then(featureStatus => {
            setIsEnabled(featureStatus.data.isAssociateScanMetricEnabled || false);
        });
    }, []);

    if (isEnabled === null) {
        return (
            <Column spacing="medium" spacingInset={spacingInset_shorthand2}>
                <PageHeader {...PAGE_HEADERS.ASSOCIATE}/>
            </Column>
        );
    }

    return (
        <Column spacing="medium" spacingInset={spacingInset_shorthand2}>
            <PageHeader {...PAGE_HEADERS.ASSOCIATE}/>
            { isEnabled && (
                <AssociateScanContextProvider>
                    <AssociateScanChartView/>
                </AssociateScanContextProvider>
            )}
            { !isEnabled && (
                <AssociateFilterContextProvider>
                    <AssociateFilter/>
                    <AssociatePerformanceContextProvider>
                        <AssociatePerformance/>
                    </AssociatePerformanceContextProvider>
                </AssociateFilterContextProvider>
            )}
        </Column>
    )
}
export default Associate


// WEBPACK FOOTER //
// ./src/components/associate/Associate.js